module.exports = __webpack_public_path__ + "media/images/app_store_button-30d676719ec3b1b9c6a5eb7f6d809f9f.png";